import { RotatingLines } from "react-loader-spinner";

interface ILoaderProps {
    text: string;
    width?: string;
}

const Loader: React.FC<ILoaderProps> = (loaderProps) => {
    let strWidth = loaderProps.width;
    if (!strWidth) {
        strWidth = "100";
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", textAlign: "center", }}>
            <div>
                <RotatingLines
                strokeColor="#A14E16"
                strokeWidth="5"
                animationDuration="0.75"
                width = {strWidth}
                visible={true}
                />
            </div>
            <div>{loaderProps.text}</div>
        </div>
    )
}

export default Loader;
